/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState, start_hour, end_hour } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClose, seq } = props;
  const token = localStorage.getItem("token");
  const [sdate, setSdate] = useState(null);
  const [amount, setAmount] = useState(0);
  const [method, setMethod] = useState("");
  const [pid, setPid] = useState("");
  const [yoil, setYoil] = useState("");
  const [open, setOpen] = useState('');
  const [close, setClose] = useState("");
  const [state, setState] = useState("");

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    seq: seq,
    sdate: "",
    pid: "",
    method: "",
  });

  const onChangeMethod = (e) => {
    setMethod(e.target.value);
    setData((state) => {
      return { ...state, method: e.target.value };
    });
  };

  const onSubmit = async () => {
    // pr('seq='+seq);
    // pr('sdate='+sdate);
    // pr('pid='+pid);
    // pr('method='+method);
    // pr('amount='+amount);

    let result = await axios.post(
      configState.api + "/gympass_admin/center_open_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        yoil: yoil,
        open: open,
        close: close,
        state: state,        
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClose();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/center_open_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: data.seq,
      }
    );
    if (result.data.success === 1) {
      setYoil(result.data.row.yoil);
      setOpen(result.data.row.open);
      setClose(result.data.row.close);
      setState(result.data.row.state);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/center_open_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClose();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Box>
      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        <Box>
          <FormControl fullWidth size="small" sx={{ width: 120 }}>
            <InputLabel>요일</InputLabel>
            <Select
              name="yoil"
              label="요일"
              value={yoil}
              onChange={(e) => {
                setYoil(e.target.value);
              }}
            >
              <MenuItem value="월">월</MenuItem>
              <MenuItem value="화">화</MenuItem>
              <MenuItem value="수">수</MenuItem>
              <MenuItem value="목">목</MenuItem>
              <MenuItem value="금">금</MenuItem>
              <MenuItem value="토">토</MenuItem>
              <MenuItem value="일">일</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ mt: 1 }}>
          <FormControl size="small" sx={{ width: 120 }}>
            <InputLabel>시작시간</InputLabel>
            <Select
              name="open"
              label="시작시간"
              value={open}
              onChange={(e) => {
                setOpen(e.target.value);
              }}
            >
              { start_hour.map((item, index) => { 
                return <MenuItem key={index} value={item}>{item}</MenuItem>
              }) }
              
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ ml: 1, width: 120 }}>
            <InputLabel>종료시간</InputLabel>
            <Select
              name="close"
              label="종료시간"
              value={close}
              onChange={(e) => {
                setClose(e.target.value);
              }}
            >
              { end_hour.map((item, index) => { 
                return <MenuItem key={index} value={item}>{item}</MenuItem>
              }) }
            </Select>
          </FormControl>
        </Box>

        {/* 상태 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>상태</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="state"
            onChange={(e) => setState(e.target.value)}
            value={state}
          >
            <FormControlLabel value="Y" control={<Radio />} label="Y" />
            <FormControlLabel value="" control={<Radio />} label="N" />
          </RadioGroup>
        </FormControl>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClose}
          >
            취소
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onDeleteClick}
          >
            삭제
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;
